export enum CandidateDeclarationSource {
  ENVD = "ENVD",
  CONSIGNMENT_ATTACHMENT_OCR = "CONSIGNMENT_ATTACHMENT_OCR",
}
